import { useState } from "react";
import {
  Card,
  Upload,
  Button,
  Alert,
  Input,
  message,
  Typography,
  Layout,
} from "antd";
import { UploadOutlined, UserOutlined } from "@ant-design/icons";
import Sidebar from "../layout/sidebar";
import api from "../api/api";

const { Content } = Layout;
const { Text } = Typography;

export default function CargaCsvNorma() {
  const [loading, setLoading] = useState(false);
  const [responseApi, setResponseApi] = useState(null);
  const [idUsuario, setIdUsuario] = useState("");

  const username = localStorage.getItem("username");

  const handleUpload = async ({ file }) => {
    if (!file.name.endsWith(".csv")) {
      message.error("Solo se permiten archivos .csv");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    setLoading(true);
    setResponseApi(null);

    try {
      const res = await api.post(
        `/api/v2/CargaStoragePdfNorma/${username}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            usuario: username || "",
          },
        }
      );

      setResponseApi({
        tipo: "success",
        mensaje: res.data,
      });

      message.success("Archivo enviado correctamente");
    } catch (error) {
      const errorMsg =
        error.response?.data || "Error al procesar el archivo CSV";

      setResponseApi({
        tipo: "error",
        mensaje: errorMsg,
      });

      message.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout
        style={{
          marginLeft: 200,
          padding: 20,
          background: "#f5f7fa",
        }}
      >
        <Content>
          <Card
            title="Carga Masiva de Normas (CSV)"
            style={{ maxWidth: 600, margin: "0 auto" }}
          >
            <div style={{ marginBottom: 16 }}>
              <Text strong>
                <UserOutlined /> Usuario:{" "}
              </Text>
              <Text>{username || "No disponible"}</Text>
            </div>
            <Upload
              accept=".csv"
              customRequest={handleUpload}
              showUploadList={false}
            >
              <Button
                icon={<UploadOutlined />}
                type="primary"
                loading={loading}
                block
              >
                {loading ? "Cargando..." : "Seleccionar y enviar CSV"}
              </Button>
            </Upload>

            {/* 🔔 Resultado */}
            {responseApi && (
              <Alert
                style={{ marginTop: 24 }}
                type={responseApi.tipo}
                showIcon
                message="Resultado del proceso"
                description={responseApi.mensaje}
              />
            )}
          </Card>
        </Content>
      </Layout>
    </Layout>
  );
}